import { render, staticRenderFns } from "./ResolvedConversations.vue?vue&type=template&id=f9cfe168&scoped=true&"
import script from "./ResolvedConversations.vue?vue&type=script&lang=js&"
export * from "./ResolvedConversations.vue?vue&type=script&lang=js&"
import style0 from "./ResolvedConversations.vue?vue&type=style&index=0&id=f9cfe168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cfe168",
  null
  
)

export default component.exports